import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'terms-of-service-page-component',
  templateUrl: './terms-of-service-page.component.html',
  styleUrl: './terms-of-service-page.component.scss',
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class TermsOfServicePage {
  public lang: string | null = null;
  constructor(private translateService: TranslateService) {
    this.lang = this.translateService.currentLang;
  }
}